import {
    Condition,
    Conditions,
    ConditionTypes,
    Operators,
} from "@tenforce/product-fields"
import { FilterParser } from "./index"
import { ConditionDTO } from "../../models/dto/conditions"
import { DecimalConditionDTO } from "../../models/dto/conditions/DecimalCondition"

export const DecimalConditionDTOType = "#TF.DecimalFieldCondition"
export const DecimalFieldDefinitionType = "#TF.NumberFieldDefinition"
export enum DecimalOperatorDTO {
    IsEmpty = "IsEmpty",
    IsEqualTo = "IsEqualTo",
    IsNotEqualTo = "IsNotEqualTo",
    IsLessThan = "IsLessThan",
    IsLessThanOrEqualTo = "IsLessThanOrEqualTo",
    IsGreaterThan = "IsGreaterThan",
    IsGreaterThanOrEqualTo = "IsGreaterThanOrEqualTo",
}

const checkIfApplicable = (condition: Condition): boolean => {
    return condition?.type === ConditionTypes.Decimal
}

const isValidNumber = (value: unknown): boolean => {
    return typeof value === "number"
}

const parseFromDTO = (condition: ConditionDTO): Conditions["Decimal"] => {
    let result: Conditions["Decimal"] = null
    switch (condition.Operator) {
        case DecimalOperatorDTO.IsEmpty: {
            result = {
                type: ConditionTypes.Decimal,
                operator: Operators.Decimal.IsEmpty,
                value: null,
                isLocked: condition.IsLocked,
            }
            break
        }
        case DecimalOperatorDTO.IsEqualTo: {
            if (isValidNumber(condition.Value)) {
                result = {
                    type: ConditionTypes.Decimal,
                    operator: Operators.Decimal.IsEqualTo,
                    value: condition.Value,
                    isLocked: condition.IsLocked,
                }
            }
            break
        }
        case DecimalOperatorDTO.IsNotEqualTo: {
            if (isValidNumber(condition.Value)) {
                result = {
                    type: ConditionTypes.Decimal,
                    operator: Operators.Decimal.IsNotEqualTo,
                    value: condition.Value,
                    isLocked: condition.IsLocked,
                }
            }
            break
        }
        case DecimalOperatorDTO.IsLessThan: {
            if (isValidNumber(condition.Value)) {
                result = {
                    type: ConditionTypes.Decimal,
                    operator: Operators.Decimal.IsLessThan,
                    value: condition.Value,
                    isLocked: condition.IsLocked,
                }
            }
            break
        }
        case DecimalOperatorDTO.IsLessThanOrEqualTo: {
            if (isValidNumber(condition.Value)) {
                result = {
                    type: ConditionTypes.Decimal,
                    operator: Operators.Decimal.IsLessThanOrEqualTo,
                    value: condition.Value,
                    isLocked: condition.IsLocked,
                }
            }
            break
        }
        case DecimalOperatorDTO.IsGreaterThan: {
            if (isValidNumber(condition.Value)) {
                result = {
                    type: ConditionTypes.Decimal,
                    operator: Operators.Decimal.IsGreaterThan,
                    value: condition.Value,
                    isLocked: condition.IsLocked,
                }
            }
            break
        }
        case DecimalOperatorDTO.IsGreaterThanOrEqualTo: {
            if (isValidNumber(condition.Value)) {
                result = {
                    type: ConditionTypes.Decimal,
                    operator: Operators.Decimal.IsGreaterThanOrEqualTo,
                    value: condition.Value,
                    isLocked: condition.IsLocked,
                }
            }
            break
        }
        default:
            break
    }
    return result
}

const parseToDTO = (
    id: string,
    condition: Condition,
): DecimalConditionDTO | null => {
    if (!condition || !checkIfApplicable(condition)) {
        return null
    }
    let result: DecimalConditionDTO | null = null
    switch (condition.operator) {
        case Operators.Decimal.IsEmpty: {
            result = {
                "@type": DecimalConditionDTOType,
                Operator: DecimalOperatorDTO.IsEmpty,
                IsLocked: condition.isLocked,
                FieldDefinition: {
                    Id: id,
                },
            }
            break
        }
        case Operators.Decimal.IsEqualTo: {
            result = {
                "@type": DecimalConditionDTOType,
                Operator: DecimalOperatorDTO.IsEqualTo,
                Value: condition.value,
                IsLocked: condition.isLocked,
                FieldDefinition: {
                    Id: id,
                },
            }
            break
        }
        case Operators.Decimal.IsNotEqualTo: {
            result = {
                "@type": DecimalConditionDTOType,
                Operator: DecimalOperatorDTO.IsNotEqualTo,
                Value: condition.value,
                IsLocked: condition.isLocked,
                FieldDefinition: {
                    Id: id,
                },
            }
            break
        }
        case Operators.Decimal.IsLessThan: {
            result = {
                "@type": DecimalConditionDTOType,
                Operator: DecimalOperatorDTO.IsLessThan,
                Value: condition.value,
                IsLocked: condition.isLocked,
                FieldDefinition: {
                    Id: id,
                },
            }
            break
        }
        case Operators.Decimal.IsLessThanOrEqualTo: {
            result = {
                "@type": DecimalConditionDTOType,
                Operator: DecimalOperatorDTO.IsLessThanOrEqualTo,
                Value: condition.value,
                IsLocked: condition.isLocked,
                FieldDefinition: {
                    Id: id,
                },
            }
            break
        }
        case Operators.Decimal.IsGreaterThan: {
            result = {
                "@type": DecimalConditionDTOType,
                Operator: DecimalOperatorDTO.IsGreaterThan,
                Value: condition.value,
                IsLocked: condition.isLocked,
                FieldDefinition: {
                    Id: id,
                },
            }
            break
        }
        case Operators.Decimal.IsGreaterThanOrEqualTo: {
            result = {
                "@type": DecimalConditionDTOType,
                Operator: DecimalOperatorDTO.IsGreaterThanOrEqualTo,
                Value: condition.value,
                IsLocked: condition.isLocked,
                FieldDefinition: {
                    Id: id,
                },
            }
            break
        }
        default:
            break
    }
    return result
}

const parser: FilterParser = {
    Type: ConditionTypes.Decimal,
    DefinitionDTOType: DecimalFieldDefinitionType,
    checkIfApplicable,
    parseFromDTO,
    parseToDTO,
}
export default parser
